module.exports = __webpack_public_path__ + "img/linkedin.efa64c0a.svg";